var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    _vm._l(_vm.list, function(obj, index) {
      return _c("CompassLink", {
        key: index,
        attrs: { label: _vm.getLabel(obj.name, index), link: obj.link }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }